import { cn } from "@/lib/utils";

export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8" data-testid={testId}>
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground mb-1">Veaimpex · VIPL</p>
        <h1 className="text-3xl sm:text-4xl font-display font-black tracking-tighter">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, sub, icon: Icon, tone = "default", testId }) {
  const tones = {
    default: "text-primary",
    success: "text-success",
    warning: "text-[hsl(var(--warning))]",
    destructive: "text-destructive",
  };
  return (
    <div className="border border-border bg-card p-5 hover:-translate-y-1 transition-transform duration-200 hover:hard-shadow rounded-sm" data-testid={testId}>
      <div className="flex items-start justify-between">
        <p className="text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground">{label}</p>
        {Icon && <Icon className={cn("h-5 w-5", tones[tone])} strokeWidth={2.2} />}
      </div>
      <p className="text-3xl font-display font-black tracking-tight mt-3">{value}</p>
      {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
    </div>
  );
}

const STATUS_STYLES = {
  Pending: "bg-[hsl(var(--warning))]/15 text-[hsl(45_100%_30%)] border-[hsl(var(--warning))]/40",
  "In Progress": "bg-primary/10 text-primary border-primary/30",
  Completed: "bg-success/15 text-success border-success/40",
  Active: "bg-success/15 text-success border-success/40",
  Ongoing: "bg-primary/10 text-primary border-primary/30",
  Inactive: "bg-muted text-muted-foreground border-border",
  Dead: "bg-destructive/10 text-destructive border-destructive/30",
};

export function StatusBadge({ status, testId }) {
  const style = STATUS_STYLES[status] || "bg-muted text-muted-foreground border-border";
  return (
    <span className={cn("inline-flex items-center px-2 py-0.5 text-xs font-bold uppercase tracking-wide border rounded-sm", style)} data-testid={testId}>
      {status}
    </span>
  );
}

export function Empty({ icon: Icon, title, sub }) {
  return (
    <div className="border border-dashed border-border rounded-sm p-12 text-center">
      {Icon && <Icon className="h-10 w-10 mx-auto text-muted-foreground mb-3" strokeWidth={1.5} />}
      <p className="font-display font-bold text-lg">{title}</p>
      {sub && <p className="text-sm text-muted-foreground mt-1">{sub}</p>}
    </div>
  );
}
